import React from "react";

interface MessageBannerProps {
  message: string;
  type: "error" | "success";
}

const MessageBanner: React.FC<MessageBannerProps> = ({ message, type }) => {
  const isError = type === "error";

  return (
    <div
      className={`mx-6 mb-4 mt-4 rounded-md border p-3 ${
        isError
          ? "border-red-200 bg-red-50 dark:border-red-700 dark:bg-red-900"
          : "border-green-200 bg-green-50 dark:border-green-700 dark:bg-green-900"
      }`}
    >
      <p
        className={`text-sm ${
          isError
            ? "text-red-800 dark:text-red-200"
            : "text-green-800 dark:text-green-200"
        }`}
      >
        {message}
      </p>
    </div>
  );
};

export default MessageBanner;
